import request from '@/utils/request'

let PointsApi = {
  /*充值套餐*/
  listPlan(data, errorback) {
    return request._post('/shop/plus.live.plan/index', data, errorback);
  },
  /*添加套餐*/
  addPlan(data, errorback) {
    return request._get('/shop/plus.live.plan/add', data, errorback);
  },
  /*修改套餐*/
  editPlan(data, errorback) {
    return request._post('/shop/plus.live.plan/edit', data, errorback);
  },
  /*删除套餐*/
  deletePlan(data, errorback) {
    return request._get('/shop/plus.live.plan/delete', data, errorback);
  },
  /*余额充值记录*/
  log(data, errorback) {
    return request._post('/shop/plus.live.plan/log', data, errorback);
  },
  /*会员充值记录*/
  Viplog(data, errorback) {
    return request._post('/shop/cash.Viplog/index', data, errorback);
  },
}
export default PointsApi;



// WEBPACK FOOTER //
// ./src/api/plan.js